
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import PhilosophyPage from '../pages/philosophy/page';
import CompanyPage from '../pages/company/page';
import ServicesPage from '../pages/services/page';
import ProjectsPage from '../pages/projects/page';
import NewsPage from '../pages/news/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/philosophy',
    element: <PhilosophyPage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
